import { t } from '@lingui/macro';

export const LOGIN_ERRORS = {
    INCORRECT_USERNAME_OR_PASSWORD_KEY: 'login_403',
    USER_DISABLED_KEY: 'login_401',
    USER_LOCKED_OUT_KEY: 'login_lockedout',
    USER_LACKS_PERMISSION_KEY: 'user_lacks_permission',
    ROLE_MISMATCH: 'user_role_mismatch_forbidden',
    UNAUTHORIZED_KEY: 'user_lacks_permission',
    LDAP_BIND_FAILED_KEY: 'ldap_bind_failed',
    GENERIC: 'login_error',
    MULTIPLE_EMAIL_EXISTS_KEY: 'multiple_email_exists',
    NG1_NGP_EMAIL_COLLISION: 'ngp_ng1_email_exists',
};

export const LOGIN_ERROR_MESSAGES = {
    [LOGIN_ERRORS.INCORRECT_USERNAME_OR_PASSWORD_KEY]: t`We're sorry, but you used a User ID and/or password that doesn't match our records.`,
    [LOGIN_ERRORS.USER_DISABLED_KEY]: t`This account has been disabled. Please contact your site administrator for support.`,
    [LOGIN_ERRORS.USER_LOCKED_OUT_KEY]: t`Account has been locked out. Please contact your site administrator for support.`,
    [LOGIN_ERRORS.USER_LACKS_PERMISSION_KEY]: t`This account does not have the proper authorization to log in. Please contact your site administrator for support.`,
    [LOGIN_ERRORS.ROLE_MISMATCH]: t`This account does not have the proper authorization to log in. Please contact your site administrator for support.`,
    [LOGIN_ERRORS.UNAUTHORIZED_KEY]: t`This account does not have the proper authorization, please login again. If you continue to have issues contact, please contact your site administrator for support.`,
    [LOGIN_ERRORS.LDAP_BIND_FAILED_KEY]: t`Failed to connect to the configured LDAP server.`,
    [LOGIN_ERRORS.GENERIC]: t`Login failed - please try to login again. If you continue to have issues please contact your site administrator for support.`,
    [LOGIN_ERRORS.MULTIPLE_EMAIL_EXISTS_KEY]: t`nGeniusOne user's email address already exists. Enter a user name with a different email.`,
    [LOGIN_ERRORS.NG1_NGP_EMAIL_COLLISION]: t`Provided email address is not unique. Enter username to proceed with authentication.`,
};
